import React from "react";

function Preloader() {
  return <div>Hello</div>;
}

export default Preloader;
